export type SubjectCategory = "quran" | "arabic";

export type SubjectDef = {
  en: string;
  ar: string;
  category: SubjectCategory;
  icon: string;
};

export const SUBJECTS: Record<string, SubjectDef> = {
  quran_recitation:    { en: "Qur'an Recitation",           ar: "تلاوة القرآن",      category: "quran", icon: "book-open" },
  tajweed:             { en: "Tajweed",                      ar: "التجويد",           category: "quran", icon: "music" },
  quran_memorization:  { en: "Qur'an Memorization (Hifz)",  ar: "حفظ القرآن",        category: "quran", icon: "star" },
  quran_revision:      { en: "Qur'an Revision (Muraja'ah)", ar: "مراجعة القرآن",     category: "quran", icon: "refresh" },
  quran_for_children:  { en: "Qur'an for Children",         ar: "القرآن للأطفال",    category: "quran", icon: "sparkles" },
  ijazah_prep:         { en: "Ijazah Preparation",          ar: "الإجازة في القرآن", category: "quran", icon: "trophy" },
  arabic_reading:      { en: "Arabic Reading & Writing",    ar: "القراءة والكتابة",  category: "arabic", icon: "pencil" },
  quranic_arabic:      { en: "Qur'anic Arabic",             ar: "العربية القرآنية",  category: "arabic", icon: "scroll" },
  classical_arabic:    { en: "Classical Arabic / Fusha",    ar: "الفصحى",            category: "arabic", icon: "mosque" },
  arabic_grammar:      { en: "Arabic Grammar (Nahw & Sarf)",ar: "النحو والصرف",      category: "arabic", icon: "ruler" },
  arabic_for_children: { en: "Arabic for Children",         ar: "العربية للأطفال",   category: "arabic", icon: "balloon" },
  arabic_conversation: { en: "Arabic Conversation",         ar: "المحادثة العربية",  category: "arabic", icon: "message" },
};

export const subjectIds = Object.keys(SUBJECTS);

export const subjectLabel = (id: string, lang: string): string => {
  const subject = SUBJECTS[id];
  if (!subject) return id;
  return lang === "ar" ? subject.ar : subject.en;
};

export const quranSubjectIds = subjectIds.filter(id => SUBJECTS[id].category === "quran");
export const arabicSubjectIds = subjectIds.filter(id => SUBJECTS[id].category === "arabic");
